var _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavPayIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.51 50.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.13px;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #ffc139;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1.57,
    y: 1.57,
    width: 47.38,
    height: 47.38
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1.57 10.67 1.57 1.57 10.67 1.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "39.83 1.57 48.94 1.57 48.94 10.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "48.94 39.83 48.94 48.94 39.83 48.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "10.67 48.94 1.57 48.94 1.57 39.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.54,
    y: 9.54,
    width: 10.47,
    height: 10.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.49,
    y: 9.54,
    width: 10.47,
    height: 10.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.54,
    y: 30.49,
    width: 10.47,
    height: 10.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.49,
    y1: 30.49,
    x2: 30.49,
    y2: 34.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.96,
    y1: 30.49,
    x2: 36.73,
    y2: 30.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 40.96,
    y1: 40.96,
    x2: 30.49,
    y2: 40.96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPayIconBlack);
export default __webpack_public_path__ + "static/media/nav-pay-icon-black.bab5a818825a2e7623ffd7f2e91afd8a.svg";
export { ForwardRef as ReactComponent };